import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import PasswordChangeForm from './PasswordChangeForm';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSun, FiMoon, FiLogOut, FiHome, FiSettings, FiLock } = FiIcons;

const Header = ({ currentUser, signOut, setCurrentView }) => {
  const { isDark, toggleTheme } = useTheme();
  const [showPasswordForm, setShowPasswordForm] = React.useState(false);
  const [showUserMenu, setShowUserMenu] = React.useState(false);

  const handleLogout = async () => {
    try {
      await signOut();
      setCurrentView('landing');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const handlePasswordChangeSuccess = () => {
    // You could show a success message here
    console.log('Password changed successfully');
  };

  return (
    <>
      <header className={`${isDark ? 'bg-gradient-to-r from-blue-900 to-blue-800 border-blue-700' : 'bg-gradient-to-r from-blue-600 to-blue-700'} text-white shadow-lg border-b`}>
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-3">
              <div className={`p-2 rounded-lg ${isDark ? 'bg-blue-800' : 'bg-blue-500'}`}>
                <SafeIcon icon={FiHome} className="text-2xl" />
              </div>
              <div>
                <h1 className="text-2xl font-bold">HomeScout</h1>
                <p className="text-sm opacity-90">
                  {currentUser?.role === 'admin' ? 'Pannello Amministratore' : 'Portale Segnalazioni'}
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              {/* User Menu */}
              <div className="relative">
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  className={`hidden sm:flex items-center space-x-2 px-3 py-1 rounded-full text-sm ${isDark ? 'bg-blue-800 hover:bg-blue-700' : 'bg-blue-500 hover:bg-blue-600'} transition-colors`}
                >
                  <span className="opacity-90">Ciao,</span>
                  <span className="font-medium">{currentUser?.email}</span>
                  <SafeIcon icon={FiSettings} className="w-4 h-4 ml-1" />
                </button>

                {/* Dropdown Menu */}
                {showUserMenu && (
                  <div className={`absolute right-0 mt-2 w-48 ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-lg shadow-lg z-50`}>
                    <button
                      onClick={() => {
                        setShowPasswordForm(true);
                        setShowUserMenu(false);
                      }}
                      className={`w-full flex items-center space-x-2 px-4 py-3 text-sm text-left transition-colors ${
                        isDark ? 'text-gray-300 hover:bg-gray-700' : 'text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      <SafeIcon icon={FiLock} className="w-4 h-4" />
                      <span>Cambia Password</span>
                    </button>
                  </div>
                )}
              </div>

              {/* Theme Toggle */}
              <button
                onClick={toggleTheme}
                className={`p-2 rounded-lg transition-colors ${isDark ? 'bg-blue-800 hover:bg-blue-700' : 'bg-blue-500 hover:bg-blue-600'}`}
                title={isDark ? 'Modalità chiara' : 'Modalità scura'}
              >
                <SafeIcon icon={isDark ? FiSun : FiMoon} className="w-5 h-5" />
              </button>

              {/* Logout */}
              <button
                onClick={handleLogout}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${isDark ? 'bg-red-800 hover:bg-red-700' : 'bg-red-600 hover:bg-red-700'}`}
              >
                <SafeIcon icon={FiLogOut} className="w-4 h-4" />
                <span className="hidden sm:inline">Logout</span>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile User Info */}
        <div className="sm:hidden px-4 pb-2">
          <div className="flex items-center justify-between">
            <span className="text-sm opacity-90">
              Ciao, <span className="font-medium">{currentUser?.email}</span>
            </span>
            <button
              onClick={() => setShowPasswordForm(true)}
              className={`flex items-center space-x-1 px-2 py-1 rounded text-xs ${isDark ? 'bg-blue-800 hover:bg-blue-700' : 'bg-blue-500 hover:bg-blue-600'} transition-colors`}
            >
              <SafeIcon icon={FiLock} className="w-3 h-3" />
              <span>Password</span>
            </button>
          </div>
        </div>
      </header>

      {/* Password Change Form */}
      {showPasswordForm && (
        <PasswordChangeForm
          currentUser={currentUser}
          onClose={() => setShowPasswordForm(false)}
          onSuccess={handlePasswordChangeSuccess}
        />
      )}

      {/* Click outside to close user menu */}
      {showUserMenu && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setShowUserMenu(false)}
        />
      )}
    </>
  );
};

export default Header;